export enum WSErrors {
  UNAUTHORIZED = 'Don\'t have right',
  TO_MANY_REQUESTS = 'DCC API: #10: Failed, try again after some time',
}